// hooks/useDebouncedEffect.js
import { useEffect } from "react";

export default function useDebouncedEffect(effect, deps, delay) {
  useEffect(() => {
    const handler = setTimeout(() => {
      effect();
    }, delay);

    return () => clearTimeout(handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delay, ...deps]); // effect は入れない
}